module.exports = __webpack_public_path__ + "img/Goin_2.737ae76a.jpg";